module.exports = __webpack_public_path__ + "img/step3_jd.711cdb73.png";